import React from 'react';
import { FadeIn } from './FadeIn';
import { Pill, Clock, MessageCircle } from 'lucide-react';
export function IndustrySection() {
  const lies = [{
    icon: <Pill className="w-8 h-8 text-gold" data-id="element-75" />,
    title: 'Blue Pills',
    description: 'They only provide a temporary patch, damage your heart in the long run, and make you dependent. They don’t fix the root cause.'
  }, {
    icon: <Clock className="w-8 h-8 text-gold" data-id="element-76" />,
    title: 'Age Myths',
    description: 'They tell you "it’s normal for your age." Lie. There are 60-year-old men with better performance than 30-year-olds. It’s biology, not chronology.'
  }, {
    icon: <MessageCircle className="w-8 h-8 text-gold" data-id="element-77" />,
    title: 'Generic Advice',
    description: '"Just relax." The worst advice possible when your nervous system is hijacked by performance anxiety.'
  }];
  return <section className="py-24 px-6 bg-dark" data-id="element-78">
      <div className="max-w-5xl mx-auto" data-id="element-79">
        <FadeIn data-id="element-80">
          <div className="text-center mb-16" data-id="element-81">
            <h2 className="text-4xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-82">
              The industry has <span className="text-gold italic" data-id="element-83">lied</span> to
              you.
            </h2>
            <div className="text-lg text-gray-400 max-w-3xl mx-auto space-y-4" data-id="element-84">
              <p data-id="element-85">
                They sell you blue pills that only provide a temporary patch,
                but damage your heart and don’t fix the root cause. Or they tell
                you "it’s just age." Lie.
              </p>
              <p data-id="element-86">
                Your body is a{' '}
                <span className="text-white font-semibold" data-id="element-87">
                  perfect biological machine
                </span>
                . If it’s failing, it’s because your{' '}
                <span className="text-white font-semibold" data-id="element-88">
                  Nitric Oxide levels are low
                </span>
                , your{' '}
                <span className="text-white font-semibold" data-id="element-89">
                  testosterone is hijacked by stress
                </span>
                , and your{' '}
                <span className="text-white font-semibold" data-id="element-90">
                  arteries have lost elasticity
                </span>{' '}
                due to modern life.
              </p>
            </div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-91">
          {lies.map((lie, index) => <FadeIn key={index} delay={0.1 * (index + 1)} data-id="element-92">
              <div className="bg-dark-card border border-gold/20 p-8 rounded-sm h-full hover:border-gold/50 transition-colors duration-300 group" data-id="element-93">
                <div className="bg-dark-lighter w-16 h-16 rounded-full flex items-center justify-center mb-6 border border-gold/10 group-hover:scale-110 transition-transform duration-300" data-id="element-94">
                  {lie.icon}
                </div>
                <h3 className="text-xl font-serif font-bold text-white mb-4" data-id="element-95">
                  {lie.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-96">
                  {lie.description}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}